import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { _MarketPlaceCategory } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";

interface Props {
    idMarketPlace: number;
}

export const MarketPlaceCategory = ({ idMarketPlace }: Props) => {

    const markcat = useDataBean(_MarketPlaceCategory);

    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idMarketPlace])

    const getLista = () => {

        markcat.instance.getMarketPlaceCategoryCatalog(idMarketPlace).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        markcat.setBean({
            IDMarketPlace: idMarketPlace
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {

        markcat.instance.deleteMarketPlaceCategory(markcat.bean.IDMarketPlaceCategory).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )
    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        markcat.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDMarketPlaceCategory', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Habilitado', property: 'Enabled', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={markcat.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Nombre</label>
                            <input type="text" name="Name" className="form-control" value={markcat.bean.Name} onChange={markcat.handleChange} />
                        </div>
                        <div className="col-md-12">
                            <BasicSwitch label="Habilitado" estado={markcat.bean.Enabled} eventChange={(e: any) => { markcat.setBean({ ...markcat.bean, "Enabled": e }) }}></BasicSwitch>
                        </div>
                        <div className="col-md-12">
                            <textarea name="Description" className="form-control" value={markcat.bean.Description} onChange={markcat.handleChange} />
                        </div>

                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}